const getButtonTextColor = (repetition, active) => {
  if (active) return "#fff";
  return "#367B63";
};

export default getButtonTextColor;
